import script from "./ChatWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatWidget.vue?vue&type=script&setup=true&lang=js"

import "./ChatWidget.vue?vue&type=style&index=0&id=4b3b0094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3b0094"]])

export default __exports__